export default __webpack_public_path__ + "static/media/armor1.8fd99d7e.png";